import { FC } from 'react';
import { Box } from '@mantine/core';
import { useStyles } from './styles';
import { IRowData } from '@components/simple-table/types';
import OverflowTip from '@components/OverflowTip';
interface IItemTitleProps {
  item: IRowData;
}

export const ParentFilial: FC<IItemTitleProps> = ({ item }) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.parentWrapper}>
      <Box className={classes.content}>
        <OverflowTip sx={{ maxWidth: '80%' }} size="sm">
          {item?.ParentName}
        </OverflowTip>
      </Box>
    </Box>
  );
};
